import { CustomerStoreProvider } from '@/stores/customer-store.provider';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/customer')({
	component: CustomerLayout,
});

function CustomerLayout() {
	return (
		<CustomerStoreProvider>
			<Outlet />
		</CustomerStoreProvider>
	);
}
